var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80288 12.4992H0.832031V9.52756L9.54503 0.841603L9.54558 0.841054C9.76593 0.620705 10.0571 0.5 10.3695 0.5C10.6818 0.5 10.973 0.620572 11.1943 0.841886L12.516 2.16355L12.8695 1.81L12.516 2.16355C12.7373 2.38487 12.8579 2.67606 12.8579 2.98833C12.8579 3.30047 12.7374 3.59155 12.5163 3.81282C12.5162 3.81292 12.5161 3.81302 12.516 3.81311L3.80288 12.4992ZM10.7229 1.31289L10.3699 0.960339L10.0165 1.31256L8.69237 2.63256L8.33759 2.98622L8.69192 3.34033L10.0136 4.66116L10.3665 5.01383L10.7199 4.66172L12.0449 3.34172L12.4 2.98795L12.0454 2.63372L10.7229 1.31289ZM1.4987 11.3325V11.8325H1.9987H3.3212H3.52785L3.6742 11.6866L9.54003 5.83911L9.89469 5.48555L9.54059 5.13145L8.21892 3.80978L7.86592 3.45678L7.51236 3.80923L1.6457 9.65756L1.4987 9.8041V10.0117V11.3325ZM0.832031 15.1658H13.1654V15.8325H0.832031V15.1658Z",
    stroke: "#74788D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.025af2a26ac3e505df86b8a2b9795d76.svg";
export { ForwardRef as ReactComponent };